@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/sr-only' as sr;

p {
    margin: 0 !important;
}

.stamp-text {
    color: var.$stamp-text;
    font-size: 0.9rem;
    text-align: center;

    &.small-margin {
        margin: 6px !important;
    }
}

.change-theme-stamp {
    text-decoration: underline;
    cursor: pointer;
    background: none;
    border: none;
    width: 100%;

    &:hover,
    &:focus {
        outline: none;
        box-shadow: 0 0 0 4px var.$focus-color;
    }
}

.sr-only {
    @include sr.sr-only();
}